import { createFileRoute } from "@tanstack/react-router";
import MolinaInsurance, { config } from "@/pages/MolinaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/molina-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Molina Healthcare TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Molina insurance coverage for TMS, SAINT TMS, and SPRAVATO. Learn about prior auth and benefits verification for depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Molina Healthcare TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Molina insurance coverage for TMS, SAINT TMS, and SPRAVATO. Learn about prior auth and benefits verification for depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/molina-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/molina-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MolinaInsurance />;
}
